/** Max visible characters for invite name in visitor log tables before truncation. */
export const INVITE_NAME_MAX_DISPLAY_LENGTH = 20;
